<!-- ════════════ NAVBAR ════════════ -->
<div style="position:relative; z-index: 100; width: 100%;">
  <nav class="navbar navbar-expand-md " style="position: fixed; width: 100%; top:0;   margin: 0;">
  <div class="container">
    <a  class="navbar-brand " [routerLink]="['']">
      <img class="img-fluid " src="assets/img/dark1.png">
    </a>
    <button class="navbar-toggler" type="button" (click)="toggleNavbar()">
      <span class="navbar-toggler-icon"></span>
    </button>
<div class="collapse navbar-collapse" [class.show]="isNavbarOpen"
     style="max-height: 350px; overflow-y: auto;">      <ul class="navbar-nav mx-auto">
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['']">Home</a>
      </li>

      <li class="nav-item">
        <a class="nav-link"  href="assets/staticpages/about/index.html"
          >About Us</a
        >
      </li>
       <li class="nav-item">
        <a class="nav-link"  href="assets/staticpages/network/index.html"
          >Network</a
        >
      </li>
       <li class="nav-item"  >
        <a class="nav-link" href="assets/staticpages/home/index.html"
          >Hub</a
        >
      </li>
      <li class="nav-item">
              <a class="nav-link" [routerLink]="['/services']">Type of services</a>
            </li>
  
              
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/cf']"
                  >Card Features</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/package']"
                  >View Services</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/ai']"
                  >Additional Features</a
                >
              </li>
            
      </ul>
    </div>
  </div>
</nav>
</div>

<!-- ════════ HERO BANNER ════════ -->
<section class="terms-hero">
  <div class="container" style="position:relative;z-index:1;">
    <span class="lbl">Legal & Platform Policies</span>
    <h1>Terms &<br><span>Conditions</span></h1>
    <p>Please read these terms carefully before participating in any UMYOSPORTS ecosystem. By joining, you agree to the following policies governing expression, conduct, and platform participation.</p>
  </div>
</section>

<!-- ════════ TERMS CONTENT ════════ -->
<main class="terms-body">
  <div class="container">
    <div class="terms-wrap">
      <span class="tc-meta rv" sipScrollReveal [sipDelay]="0">Last Updated · UMYOSPORTS Platform Policies</span>

      <!-- SECTION 1 -->
      <div class="tc-card rv" sipScrollReveal [sipDelay]="0.08">
        <div class="tc-num">01</div>
        <h2 class="tc-title">Expression and Ecosystem Scope</h2>
        <p>The Platform operates as a collection of <strong>mission-specific digital ecosystems</strong>. Each ecosystem functions as a purpose-driven private online association with a defined scope of discussion.</p>
        <p>Members are encouraged to engage in open expression within the stated mission and intended purpose of the ecosystem they have joined. Expression is permitted to the extent it aligns with the ecosystem's defined focus and participation standards.</p>
        <p>Content, discussions, or activities that fall outside the stated mission or scope of a particular ecosystem may be moderated, restricted, redirected, or removed at the Company's discretion.</p>
        <p>The Company does not regulate expression based on viewpoint alone. Moderation decisions are based on alignment with ecosystem purpose, adherence to participation standards, and compliance with Platform-wide policies.</p>
        <p>Participation in any ecosystem is conditional and subject to continued compliance with applicable guidelines. Access to an ecosystem is a <strong>revocable license</strong> and may be suspended or terminated for violations of its stated mission, conduct standards, or Platform policies.</p>
        <p>Membership in one ecosystem does not grant rights, privileges, or expression authority within any other ecosystem.</p>
        <div class="tc-highlight">
          UMYO operates multiple mission-specific private digital ecosystems. Participation is voluntary and conditioned upon agreement to the mission and standards of each ecosystem. The platform does not guarantee unrestricted expression.
        </div>
        <ul class="tc-list">
          <li>Content may be moderated or removed if deemed outside the mission scope of the selected ecosystem, regardless of viewpoint.</li>
          <li>Mission-aligned expression: Speech is free within the mission of the ecosystem — not free across all topics everywhere.</li>
        </ul>
      </div>

      <!-- SECTION 2 -->
      <div class="tc-card rv" sipScrollReveal [sipDelay]="0.24">
        <div class="tc-num">02</div>
        <h2 class="tc-title">Non-Discrimination and Mission Alignment</h2>
        <p>The Company provides access to the Platform <strong>without discrimination</strong> based on race, color, religion, sex, gender identity, sexual orientation, national origin, disability, political affiliation, or other legally protected characteristics.</p>
        <p>Access to individual ecosystems is conditioned upon agreement to and compliance with that ecosystem's stated mission, scope, and participation standards. Moderation decisions are based on:</p>
        <ul class="tc-list">
          <li>Conduct and behavior within the ecosystem</li>
          <li>Mission alignment with the stated ecosystem purpose</li>
          <li>Adherence to Platform-wide policies</li>
          <li>Not on a member's personal identity or protected characteristics</li>
        </ul>
        <p>The Company reserves the right to suspend or terminate participation in any ecosystem where a member's conduct is inconsistent with its stated purpose or applicable guidelines.</p>
      </div>

      <!-- SECTION 3 -->
      <div class="tc-card rv" sipScrollReveal [sipDelay]="0.32">
        <div class="tc-num">03</div>
        <h2 class="tc-title">Member Appeals and Review Process</h2>
        <p>Members who believe a moderation action was taken in error may submit a written appeal within <strong>fourteen (14) days</strong> of the action.</p>
        <p>Appeals must include sufficient detail to allow review of the decision, including:</p>
        <ul class="tc-list">
          <li>The relevant ecosystem name</li>
          <li>Date of the moderation action</li>
          <li>A description of the basis for the appeal</li>
        </ul>
        <p>Upon receipt of a valid appeal request, the Company will conduct an internal review of the moderation decision. Review may include evaluation of the original content, applicable ecosystem guidelines, and compliance with Platform policies.</p>
        <div class="tc-highlight">
          The Company may uphold, modify, or reverse the original decision at its discretion. Decisions issued upon appeal are final.
        </div>
        <p>Submission of an appeal does not guarantee reinstatement, refund, or restoration of access. During the review period, access may remain suspended.</p>
        <p>The Company reserves the right to decline repetitive, abusive, or bad-faith appeals.</p>
      </div>

    </div>
  </div>
</main>
<!-- ════════ FOOTER ════════ -->
<footer class="ufoot">
  <div class="container">
    <img src="assets/img/dark1.png" alt="UMYO SPORTS" onerror="this.style.display='none'">
    <div class="ufb">UMYO SPORTS</div>
    <p>UmyoSports First Privacy-Gated Digital Community</p>
    <div class="d-flex justify-content-center gap-4 flex-wrap">
      <a href="/">Home</a>
      <a href="https://umyosports.site/assets/staticpages/about/index.html">About Us</a>
      <a href="https://umyosports.site/assets/staticpages/network/index.html">Network</a>
      <a href="https://umyosports.site/assets/staticpages/home/index.html">Hub</a>
      <a routerLink="/services">Type of Servcies</a>
      <a routerLink="/cf">Card Features</a>
      <a routerLink="/package">View Services</a>
      <a routerLink="/ai">Aditional Features</a>
      <a href="/terms">Terms &amp; Conditions</a>
    </div>
    <p class="ufc2">© 2025 UMYO SPORTS · Built by the community, for the community</p>
  </div>
</footer>